export const landing = {
  heroTitle: 'Toma el control de tu vida en una sola app',
  heroSubtitle: 'La plataforma todo-en-uno para profesionales que buscan máxima productividad, control financiero y crecimiento personal impulsado por IA',
  createFreeAccount: 'Crear Cuenta Gratis',
  seeDemo: 'Ver Demo',
  learnMore: 'Conocer Más',
  
  featuresTitle: 'Todo lo que necesitas para triunfar',
  
  productivityHub: 'Centro de Productividad',
  productivityHubDesc: 'Tu comando central para alcanzar metas y optimizar tu tiempo',
  goalManagement: 'Gestión de Metas y Objetivos',
  taskManagement: 'Gestión de Tareas y Proyectos',
  timeOrganization: 'Organización del Tiempo y Calendario',
  productivityAnalytics: 'Análisis de Productividad con IA',
  
  financeModule: 'Módulo de Finanzas',
  financeModuleDesc: 'Control total de tus finanzas personales con inteligencia artificial',
  smartBudgets: 'Presupuestos Inteligentes',
  expenseTracking: 'Control de Gastos e Ingresos',
  debtManagement: 'Gestión de Deudas e Inversiones',
  predictiveFinancial: 'Análisis Predictivo Financiero con IA',
  
  complementaryFeatures: 'Funcionalidades Complementarias',
  complementaryFeaturesDesc: 'Herramientas adicionales para una vida más organizada',
  personalJournal: 'Diario Personal',
  habitTracking: 'Seguimiento de Hábitos',
  listsOrganization: 'Listas y Organización',
  ideaGenerator: 'Generador de Ideas',
  documentsNotes: 'Documentos y Notas',
  emailManagement: 'Correo Electrónico',
  financialEducation: 'Educación Financiera',
  productivityEducation: 'Educación para la Productividad',
  
  howItWorksTitle: '¿Cómo funciona?',
  step1Title: 'Regístrate Gratis',
  step1Desc: 'Crea tu cuenta en segundos sin necesidad de tarjeta de crédito',
  step2Title: 'Organiza tu Vida',
  step2Desc: 'Configura tus metas, tareas, presupuestos y comienza a trabajar',
  step3Title: 'Crece con IA',
  step3Desc: 'Obtén insights inteligentes y mejora continuamente',
  
  aiAnalyticsTitle: 'Potenciado por Inteligencia Artificial',
  aiAnalyticsSubtitle: 'Descubre el poder de los análisis predictivos para tu vida',
  predictiveFinanceTitle: 'Análisis Predictivo Financiero',
  predictiveFinanceDesc: 'Proyecciones inteligentes de tus ingresos y gastos futuros basadas en patrones históricos',
  productivityAnalysisTitle: 'Análisis de Productividad',
  productivityAnalysisDesc: 'Identifica patrones y tendencias en tu uso del tiempo para maximizar tu eficiencia',
  aiFinancialAssistantTitle: 'Asistente Financiero IA',
  aiFinancialAssistantDesc: 'Recibe recomendaciones personalizadas para optimizar tus finanzas y alcanzar tus metas',
  aiAccuracy: 'Precisión IA',
  aiFaster: 'Más rápido',
  aiAvailable: 'Disponible',
  aiPossibilities: 'Posibilidades',
  
  pricingTitle: 'Planes diseñados para ti',
  monthlyPlan: 'Mensual',
  annualPlan: 'Anual',
  freePlanTitle: 'Plan Gratuito',
  freePlanDesc: 'Perfecto para comenzar',
  premiumPlanTitle: 'Plan Premium',
  premiumPlanDesc: 'Para profesionales exigentes',
  perMonth: 'por mes',
  perYear: 'por año',
  savePerYear: 'Ahorra $21.88 al año',
  seeFullComparison: 'Ver comparación completa',
  chooseFreePlan: 'Comenzar Gratis',
  choosePremiumPlan: 'Obtener Premium',
  allFeatures: 'Todas las funcionalidades',
  basicFeatures: 'Funcionalidades básicas',
  advancedAnalytics: 'Analíticas avanzadas',
  aiPowered: 'Análisis predictivo con IA',
  prioritySupport: 'Soporte prioritario',
  noAds: 'Sin publicidad',
  advancedExport: 'Exportación avanzada',
  mainDashboard: 'Dashboard principal',
  limitedFeatures: 'Funciones limitadas',
  emailSupport: 'Soporte por email',
  mostPopular: 'Más Popular',
  
  testimonialsTitle: 'Lo que dicen nuestros usuarios',
  testimonial1Text: 'PlanWiseNow transformó completamente mi manera de trabajar. Ahora puedo gestionar múltiples proyectos sin perder el control de mis finanzas.',
  testimonial1Author: 'Carlos Mendoza',
  testimonial1Role: 'Emprendedor Digital',
  testimonial2Text: 'Las analíticas con IA me ayudaron a identificar patrones en mis gastos que nunca había notado. He ahorrado más de $500 en tres meses.',
  testimonial2Author: 'María González',
  testimonial2Role: 'Freelance Designer',
  testimonial3Text: 'Como manager de equipo, necesitaba algo más que una simple app de tareas. PlanWiseNow me da la visión completa que necesito.',
  testimonial3Author: 'Roberto Silva',
  testimonial3Role: 'Project Manager',
  testimonial4Text: 'La integración de productividad y finanzas en una sola plataforma es genial. Ya no necesito 5 apps diferentes.',
  testimonial4Author: 'Ana Martínez',
  testimonial4Role: 'Consultora Independiente',
  
  faqTitle: 'Preguntas Frecuentes',
  faqQuestion1: '¿Qué incluye el plan gratuito?',
  faqAnswer1: 'El plan gratuito incluye funcionalidades básicas de todos los módulos: gestión de tareas, metas, presupuestos, diario, hábitos y más. Es perfecto para comenzar y explorar la plataforma.',
  faqQuestion2: '¿Cómo funcionan las analíticas con IA?',
  faqAnswer2: 'Nuestro sistema de IA analiza tus datos históricos de productividad y finanzas para identificar patrones, hacer predicciones y ofrecerte recomendaciones personalizadas que te ayuden a mejorar.',
  faqQuestion3: '¿Puedo cancelar en cualquier momento?',
  faqAnswer3: 'Sí, puedes cancelar tu suscripción Premium en cualquier momento desde la configuración de tu cuenta. No hay compromisos a largo plazo.',
  faqQuestion4: '¿Mis datos están seguros?',
  faqAnswer4: 'Absolutamente. Utilizamos encriptación de nivel bancario y cumplimos con todos los estándares de seguridad internacionales. Tus datos nunca serán compartidos con terceros.',
  faqQuestion5: '¿Es compatible con dispositivos móviles?',
  faqAnswer5: 'Sí, PlanWiseNow es completamente responsive y funciona perfectamente en smartphones, tablets y computadoras. Próximamente lanzaremos apps nativas.',
  faqQuestion6: '¿Ofrecen reembolsos?',
  faqAnswer6: 'Sí, ofrecemos una garantía de reembolso de 30 días en el plan Premium. Si no estás satisfecho, te devolvemos tu dinero sin preguntas.',
  
  ctaTitle: '¿Listo para transformar tu productividad?',
  ctaSubtitle: 'Únete a miles de profesionales que ya están tomando el control de su vida',
  startFreeNow: 'Comenzar Gratis Ahora',
  noCardRequired: 'No se requiere tarjeta de crédito',
  noCommitments: 'Sin compromisos',
  cancelAnytime: 'Cancela cuando quieras',
  secureData: 'Datos seguros',
  
  footerDescription: 'Tu asistente personal de productividad y finanzas',
  footerQuickLinks: 'Enlaces Rápidos',
  footerFeatures: 'Características',
  footerPricing: 'Precios',
  footerBlog: 'Blog',
  footerContact: 'Contacto',
  footerLegal: 'Legal',
  footerPrivacy: 'Política de Privacidad',
  footerTerms: 'Términos de Servicio',
  footerRefund: 'Política de Reembolsos',
  footerSocial: 'Síguenos',
  
  newsletter: {
    comingSoon: "🚀 ¡Próximamente!",
    subtitle: "Sé el Primero en Saberlo",
    description: "Únete a nuestra lista exclusiva de pre-lanzamiento y obtén acceso anticipado a PlanWiseNow. Transforma cómo gestionas tu tiempo, metas y finanzas.",
    emailPlaceholder: "tu@email.com",
    namePlaceholder: "Tu nombre (opcional)",
    later: "Tal Vez Después",
    subscribe: "¡Cuenta Conmigo!",
    subscribing: "Suscribiendo...",
    privacy: "Respetamos tu privacidad. Sin spam, nunca.",
    success: "¡Bienvenido a bordo! 🎉",
    successDesc: "Revisa tu email para los detalles de confirmación.",
    error: "¡Ups!",
    errorDesc: "Algo salió mal. Por favor intenta de nuevo.",
    emailRequired: "Por favor ingresa tu dirección de email.",
    alreadySubscribed: "¡Ya estás suscrito!",
    alreadySubscribedDesc: "Ya estás en nuestra lista. ¡Mantente atento!"
  }
};
